import { render, staticRenderFns } from "./NoticeBoardUpdate.vue?vue&type=template&id=17661bd1&"
import script from "./NoticeBoardUpdate.vue?vue&type=script&lang=ts&"
export * from "./NoticeBoardUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports